export function drawPolygon({ map, points }) {
  const polygon = new google.maps.Polygon({
    paths: points,
    strokeColor: "transparent",
    strokeOpacity: 1.0,
    fillColor: "#828fa0",
    fillOpacity: 1.0,
  });

  polygon.setMap(map);
}
